module.exports = __webpack_public_path__ + "img/wh_01.41867b50.png";